const SPACE_KEY_CODE = 32;
export const spaceBarPressed = (e: any): boolean => e.keyCode === SPACE_KEY_CODE;
